import css from './deckGraph.module.scss';

import { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { apiGetDeck } from 'core/api';
import { FrameHeader, FramePreloader } from 'core/ui/Frame';
import { useMessageModal } from 'core/ui/MessageModal';

import Exercise from './GraphExercise';

const DeckPendingGraph = () => {
  const deckUid = orDie(useParams<{ deckUid?: string }>().deckUid);
  const [{ deck, isLoading }, setState] = useState({
    deck: null as TDeck | null,
    isLoading: true,
  });
  const { showError } = useMessageModal();

  useEffect(() => {
    apiGetDeck(deckUid).then(
      deck => setState({ deck, isLoading: false }),
      () => {
        setState({ deck: null, isLoading: false });
        showError(`Cannot load the deck: "${deckUid}"`);
      }
    );
  }, []);

  return (
    <div className={css.module}>
      <FrameHeader>Your Stats</FrameHeader>
      {isLoading && <FramePreloader />}
      {deck && (
        <>
          <div className={css.exercises}>
            {deck.exercises.map(exercise => (
              <Exercise deckUid={deck.uid} key={exercise} exercise={exercise} />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default memo(DeckPendingGraph);
